module.exports = __webpack_public_path__ + "img/alipay.92049400.png";